import { render, staticRenderFns } from "./StatisticsChart.vue?vue&type=template&id=c7198274&scoped=true"
import script from "./StatisticsChart.vue?vue&type=script&lang=js"
export * from "./StatisticsChart.vue?vue&type=script&lang=js"
import style0 from "./StatisticsChart.vue?vue&type=style&index=0&id=c7198274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7198274",
  null
  
)

export default component.exports